import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { MealItemEditAction } from '../../constants/meals';
import mealsStore from '../../store/mealsStore';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import { IMealItem } from 'src/types/combo';
import { formatPrice } from 'src/utils/formatter';
import { booleanNumberReverse, getTranslate } from 'src/utils/helpers';
import { productUtils } from '~/utils/productUtils';
import { Checkbox } from '~/view/components/Controls/Checkbox/Checkbox';
import { ProductWarning } from '~/view/components/ProductWarning';
import './style.scss';

interface IProps {
  item: IMealItem;
}

const MealItem: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const editItem = useCallback(() => {
    modalStore.openMealItemEditModal({
      item: props.item.isFake ? undefined : props.item,
      sizeId: props.item.size_id,
      groupId: props.item.group_id,
      choiceId: props.item.choice_id,
      onSubmit: mealsStore.changeItemHandler,
      onDelete: mealsStore.changeItemHandler,
    });
  }, [props.item]);

  const clickDefault = useCallback(() => {
    mealsStore.changeItemHandler(MealItemEditAction.EDIT, { ...props.item, is_default: booleanNumberReverse(props.item.is_default) });
  }, [props.item]);

  return (
    <li className="meal-item__wrapper mr-2">
      {!props.item.isFake ? (
        <div className="meal-item">
          <div className="meal-item__radio-wrapper">
            <Checkbox
              name={productUtils.getMealItemKey(props.item)}
              value={Boolean(props.item.is_default)}
              onClick={clickDefault}
              appearance="circle"
              inputClassName="meal-item__radio"
            />
          </div>
          <div className="meal-item__text-wrapper pl-2" onClick={editItem}>
            <p className="meal-item__text family-semibold color-dark text-size-14 text-elipsis">{getTranslate(props.item.name)}</p>
            <p className="meal-item__text family-medium color-dark text-size-10 letter-spacing-12 text-uppercase text-elipsis mt-1">
              {localeStore.t('discounted_price') + ' ' + formatPrice(props.item.price)}
            </p>
          </div>
          <ProductWarning
            type="mealItemsInEditPage"
            comboItem={props.item}
            comboItemOrderTypeWarning={mealsStore.isConflictedItemsOrderType}
            iconType="circle"
            iconSize={21}
            marginLeft={2}
          />
        </div>
      ) : (
        <button onClick={editItem} className="meal-item__btn-add">
          {localeStore.t('add_item')}
        </button>
      )}
    </li>
  );
});

export default MealItem;
